<template>
  <div class="pay-body water-mark">
    <div>
      <van-button
        @click="year"
        icon="arrow-down"
        icon-position="right"
        round
        plain
        class="pay-time"
        size="small"
        text="选择月份"
      />
      <div class="time-title">
        <div class="time">
          <span @click="year">{{ timeTitle }}</span>
        </div>
        <div class="desc">
          实发(元)
          <img
            :src="moneyVisible === 2 ? eye : closeeye"
            @click="moneyShow([0, 2, 1][moneyVisible])"
          />
        </div>
        <div class="money">
          <span @click="moneyShow([0, 2, 1][moneyVisible])">{{
            moneyVisible === 1 ? '****' : actualMoney || '--'
          }}</span>
        </div>
      </div>
      <div
        class="money-detail"
        v-if="
          salaryData.salaryTemplateColumnDTOList &&
            salaryData.salaryTemplateColumnDTOList.length > 0
        "
      >
        <div
          v-for="(item, i) in salaryData.salaryTemplateColumnDTOList || []"
          :key="i"
        >
          <span>{{ item._title }}</span>
          <span>{{ item._value || '-' }}</span>
        </div>
      </div>
      <div v-else class="money-detail-none">
        <img
          src="https://web-data.zmlearn.com/image/kED1eTLQU5Z2mBDFeRKgU7/no_arrange.png"
        />
        <div>暂无本月薪资信息</div>
      </div>
      <van-popup
        class="common-popup"
        v-model="showPicker"
        round
        position="bottom"
      >
        <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          :min-date="minDate"
          :default-index="2"
          :max-date="maxDate"
          :formatter="formatter"
          @confirm="confirm()"
          @cancel="cancel"
        />
      </van-popup>
      <!-- <div v-if="salaryData.salaryMailConfigId" class="money-desc">
        <div>薪资注意事项说明：</div>
        <div @click="payRules">
          1、计税工资=月度工资-（入/离职缺勤扣款+病假扣款+事假扣款+旷工扣款）...
          <span>查看全部</span>
        </div>
      </div> -->
      <div class="hr-email">
        <!-- 薪资问题反馈：<span class="desc"
          >如有疑问请以邮件工资条为准，并回复该邮件</span
        > -->
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { DatetimePicker, Popup, Button, Toast, Icon, Sticky } from 'vant';
import { querySalary } from '../../api/pay';
import watermark from '../../utils/watermark';
import { geturlParams } from '@utils/index';

Vue.use(DatetimePicker)
  .use(Popup)
  .use(Button)
  .use(Toast)
  .use(Icon)
  .use(Sticky);

export default {
  data() {
    const time = new Date();
    let year = time.getFullYear();
    let month = time.getMonth() - 1;
    if (time.getMonth() === 0) {
      // 月份为1月份时
      year -= 1;
      month = 11;
    }
    const maxDate = new Date(year, month, 1);
    return {
      showPicker: false,
      salary: 'salary@zhangmen.com',
      zmwbsalary: 'zmwbsalary@youlanw.com',
      xinziteacher: 'xinziteacher@50bm.com',
      eye: 'https://web-data.zmlearn.com/image/tE7zVXVycesJQmmFmWuDfB/eye.png',
      closeeye:
        'https://web-data.zmlearn.com/image/qeRH8W4aNxFp7kveBqXsvG/closeeye.png',
      moneyVisible: 1,
      minDate: new Date(2020, 7, 1), // 默认只能查询上线后的数据
      maxDate,
      currentDate: time,
      timeTitle: '',
      salaryData: {},
      password: '',
      salaryMonth: '',
      actualMoney: '', // 实发工资
      personCode: '', // 工号
      watermarkStatus: false,
    };
  },
  created() {
    try {
      const res = window.sessionStorage.getItem('SALARY_DATA');
      if (res) {
        this.salaryData = JSON.parse(res);
        this.personCode = this.salaryData.personCode || '';
        (this.salaryData.salaryTemplateColumnDTOList || []).forEach(r => {
          if (r._field === 'actualMoney') this.actualMoney = r._value;
        });
      } else {
        let parmobj = geturlParams();
        let path = parmobj['Api-Version']
          ? `/pay/login?Api-Version=${parmobj['Api-Version']}&token=${parmobj.token}`
          : '/pay/login';
        return this.$router.push({
          path,
        });
      }
      this.password = window.sessionStorage.getItem('SALARY_PW');
      this.salaryMonth = window.sessionStorage.getItem('SALARY_DATE');
      if (this.salaryMonth) {
        this.currentDate = new Date(`${this.salaryMonth}-01`);
        this.timeTitle = `${this.salaryMonth.split('-')[0]}年${
          this.salaryMonth.split('-')[1]
        }月`;
      }
    } catch (err) {
      console.log(err);
      Toast('查询失败 请联系管理员或稍后再试');
    }
  },
  mounted() {
    this.watermark();
  },
  methods: {
    year() {
      this.showPicker = true;
    },

    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },

    confirm(val) {
      if (this.salaryMonth && val) this.currentDate = this.salaryMonth;
      const date = this.$utils.formatShortDate(this.currentDate, 'yyyy-MM');
      const params = {
        password: this.password,
        salaryMonth: date,
      };
      this.showPicker = false;
      Toast.loading({
        duration: 5000,
        forbidClick: true,
        overlay: false,
        message: '加载中...',
      });
      querySalary(params)
        .then(res => {
          if (!res) {
            Toast.clear();
            return Toast('查询失败 请稍后再试');
          }
          if (res.code == 1) {
            this.isGoLoanding = false;
            Toast(res.message || '查询失败 请稍后再试');
            return;
          }
          this.moneyVisible = 1;
          this.actualMoney = '';
          this.salaryData = res;
          this.personCode = this.salaryData.personCode || '';
          this.watermark();
          (this.salaryData.salaryTemplateColumnDTOList || []).forEach(r => {
            if (r._field === 'actualMoney') this.actualMoney = r._value;
          });
          window.sessionStorage.setItem('SALARY_DATA', JSON.stringify(res));
          if (date)
            this.timeTitle = `${date.split('-')[0]}年${date.split('-')[1]}月`;
          window.sessionStorage.setItem('SALARY_DATE', date);
        })
        .catch(err => {
          this.actualMoney = '';
          this.moneyVisible = 1;
          this.salaryData = {};
          window.sessionStorage.setItem('SALARY_DATA', JSON.stringify({}));
          this.isGoLoanding = false;
        })
        .finally(() => {
          Toast.clear();
        });
    },

    cancel() {
      this.showPicker = false;
    },

    moneyShow(val) {
      this.moneyVisible = val;
    },

    // payRules() {
    //   let parmobj = geturlParams();
    //   let path = parmobj["Api-Version"] ? `/pay/rules?Api-Version=${parmobj["Api-Version"]}&token=${parmobj.token}&salaryConfigId=${this.salaryData.salaryMailConfigId}` : '/pay/rules';
    //   this.$router.push({
    //     path,
    //   });
    // this.$router.push({
    //   path: '/pay/rules',
    //   query: { salaryConfigId: this.salaryData.salaryMailConfigId },
    // });
    // },

    watermark() {
      if (!this.watermarkStatus && this.personCode) {
        watermark({ content: this.personCode });
        this.watermarkStatus = true;
      }
    },
  },
};
</script>

<style lang="scss" scope>
.pay-body {
  padding: 20px;
  overflow-y: scroll;
  height: calc(100vh - 160px);
  -webkit-overflow-scrolling: touch;
  position: fixed;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  width: 100%;

  .pay-time {
    position: absolute;
    padding: 0 25px 0 30px;
    height: 56px;
  }
  // .date-popup {
  //   .van-picker__confirm,
  //   .van-picker__cancel {
  //     font-size: 17px;
  //     color: #1989fa !important;
  //   }
  //   .van-picker-column__item--selected {
  //     font-weight: 500;
  //   }
  // }
  .time-title {
    text-align: center;
    padding: 120px 0 40px 0;
    .time {
      font-size: 38px;
      color: #000;
      font-weight: 500;
    }
    .desc {
      font-size: 28px;
      color: #393939;
      margin: 20px 0 10px 0;
      img {
        height: 42px;
        position: relative;
        top: 8px;
      }
    }
    .money {
      font-size: 40px;
      color: #000;
      font-weight: 500;
    }
  }
  .money-detail {
    font-size: 28px;
    font-weight: 400;
    > div {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #efefef;
      margin: 25px 20px;
      padding-bottom: 20px;
      span {
        display: inline-block;
        padding: 0 5px;
      }
      span:nth-child(1) {
        color: #4a4a4a;
      }
      span:nth-child(2) {
        color: #000;
        font-size: 28px;
        font-weight: 500;
      }
    }
  }
  .money-detail-none {
    text-align: center;
    padding: 160px 0 300px 0;
    font-size: 26px;
    div {
      padding-top: 20px;
    }
  }
  .money-desc {
    padding: 20px;
    font-weight: 500;
    div:nth-child(1) {
      font-size: 28px;
      color: #252629;
    }
    div:nth-child(2) {
      padding-top: 10px;
      font-size: 26px;
      line-height: 50px;
      font-weight: 400;
    }
    span {
      color: #3690ff;
    }
  }
  .hr-email {
    padding: 20px;
    font-size: 28px;
    color: #252629;
    font-weight: 500;
    .desc {
      font-size: 26px;
      color: #606266;
      font-weight: 400;
    }
    > div {
      margin-top: 20px;
      font-size: 26px;
      font-weight: 500;
      span {
        font-weight: 400;
        color: #3690ff;
        font-size: 24px;
      }
    }
    span {
      font-size: 26px;
      font-weight: 500;
      span {
        font-weight: 400;
        color: #3690ff;
        font-size: 26px;
      }
    }
  }
}
.common-popup {
  .van-picker__confirm {
    font-size: 17px;
    color: #1989fa !important;
  }
  .van-picker__cancel {
    font-size: 17px;
  }
  .van-picker-column__item--selected {
    font-weight: 500;
  }
  .van-hairline-unset--top-bottom {
    border-top: 0.5px solid #c0c0c0;
    border-bottom: 0.5px solid #c0c0c0;
  }
}
</style>
